/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LookupInternalResponseListBaseResponse as ModelsV3CommonLookupInternalResponseListBaseResponse } from '../../models/Models/v3/Common/lookup-internal-response-list-base-response';

export interface V3PublicApplicationLookupsApplicationIdCountriesGet$Json$Params {
  applicationId: string;
}

export function v3PublicApplicationLookupsApplicationIdCountriesGet$Json(http: HttpClient, rootUrl: string, params: V3PublicApplicationLookupsApplicationIdCountriesGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3CommonLookupInternalResponseListBaseResponse>> {
  const rb = new RequestBuilder(rootUrl, v3PublicApplicationLookupsApplicationIdCountriesGet$Json.PATH, 'get');
  if (params) {
    rb.path('applicationId', params.applicationId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsV3CommonLookupInternalResponseListBaseResponse>;
    })
  );
}

v3PublicApplicationLookupsApplicationIdCountriesGet$Json.PATH = '/v3/public/application/lookups/{applicationId}/countries';
